var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { style: { width: _vm.width, height: _vm.height } }, [
    _vm._v("\n  " + _vm._s(_vm.ratio) + " " + _vm._s(_vm.loaded) + "\n  "),
    _c("img", {
      ref: "img",
      attrs: { src: _vm.url, width: _vm.width, height: _vm.imageHeight },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }